import { FontIcon } from "@fluentui/react";
import { getTheme, mergeStyles } from "@fluentui/react/lib/Styling";
import { NoRecords } from "../../components/NoRecords";

const iconClass = mergeStyles({
  fontSize: 24,
  paddingRight: 15,
});

interface NoResultsProps {
  typeText?: string;
  handleCreateOpen?: () => void;
}

export const NoResults: React.FC<NoResultsProps> = ({
  typeText = "",
  handleCreateOpen,
}) => {
  return typeText === "" ? (
    <NoRecords entryType="collection" handleCreateOpen={handleCreateOpen} />
  ) : (
    <div data-cy="no-filtered-collection-results" style={bodyStyle}>
      <FontIcon iconName="FabricFolderSearch" className={iconClass} />
      <div>
        <h3 style={headerStyle}>No Results</h3>
        <p style={contentStyle}>{`No collections matched your filter term. `}</p>
      </div>
    </div>
  );
};

const theme = getTheme();
const bodyStyle = {
  display: "flex",
  alignItems: "center",
  border: `1px solid ${theme.palette.neutralLight}`,
  borderRadius: 3,
  padding: "0 15px",
  margin: 20,
  marginLeft: 0,
};

const headerStyle = { marginBottom: 5 };
const contentStyle = { marginTop: 0 };
